import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 1350,
  height: 760,
  x: 0,
  y: 0,
  list: [
    {
      id: '690687af-edb0-4130-ad0c-a7503099b9d9',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '573f598a-5b77-4dbf-8087-a84c77b42b71',
      type: 'Container',
      name: 'topContainer',
      nameSpace: '',
      className: '',
      x: 675,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '690687af-edb0-4130-ad0c-a7503099b9d9',
      data: ''
    },
    {
      id: '8f7fb67e-c1e4-4c77-83cb-f121bb86ba22',
      type: 'Container',
      name: 'bottomContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 760,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '690687af-edb0-4130-ad0c-a7503099b9d9',
      data: ''
    },
    {
      id: '5f410c9e-5025-4e97-87a8-5544946c8ad4',
      type: 'Sprite',
      name: 'avatarNameSprite',
      nameSpace: '',
      className: '',
      x: -486,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_name',
      parent: '573f598a-5b77-4dbf-8087-a84c77b42b71',
      data: ''
    },
    {
      id: '358c703a-5303-4d99-90df-3ca799184241',
      type: 'Sprite',
      name: 'backButton',
      nameSpace: '',
      className: '',
      x: 526,
      y: 56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_arrow',
      parent: '573f598a-5b77-4dbf-8087-a84c77b42b71',
      data: ''
    },
    {
      id: '98f643b8-fcb6-4b0d-83fa-93b51a2d0195',
      type: 'Sprite',
      name: 'editButton',
      nameSpace: '',
      className: '',
      x: 96,
      y: -82,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_build',
      parent: '8f7fb67e-c1e4-4c77-83cb-f121bb86ba22',
      data: ''
    },
    {
      id: '1dfdda9a-58b8-477b-87f3-90472cca8be6',
      type: 'Sprite',
      name: 'shareButton',
      nameSpace: '',
      className: '',
      x: 250,
      y: -77,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'farm_share',
      parent: '8f7fb67e-c1e4-4c77-83cb-f121bb86ba22',
      data: ''
    },
    {
      id: '3828d629-0248-4cd7-8b45-581c3681336b',
      type: 'Sprite',
      name: 'avatar',
      nameSpace: '',
      className: '',
      x: -132,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'no_avatar',
      parent: '5f410c9e-5025-4e97-87a8-5544946c8ad4',
      data: ''
    },
    {
      id: '0d14a210-312e-4c8c-8621-b3cc2efb372c',
      type: 'Graphics',
      name: 'circleMask',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5f410c9e-5025-4e97-87a8-5544946c8ad4',
      bake: false,
      commands: [
        {
          id: 'c9930fec-95a0-448b-a71a-f23d3263e653',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        },
        {
          id: 'db4953af-99ca-4ca5-914e-109439c8aace',
          type: 'drawCircle',
          x: 0,
          y: 0,
          radius: 45
        },
        {
          id: '17de96dd-ca08-45c5-9e38-f2d03ab8c11e',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        }
      ],
      data: ''
    },
    {
      id: 'f88e6fbd-ea32-487c-beda-db6a6abc7885',
      type: 'Sprite',
      name: 'avatarBorder',
      nameSpace: '',
      className: '',
      x: -132,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_avatar',
      parent: '5f410c9e-5025-4e97-87a8-5544946c8ad4',
      data: ''
    },
    {
      id: 'b26e6f32-dca8-496a-bbf2-38155de14c1f',
      type: 'Text',
      name: 'nameText',
      nameSpace: '',
      className: '',
      x: 20,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'MyFarm',
      localize: true,
      maxWidth: 200,
      maxHeight: 45,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#892e2e',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '5f410c9e-5025-4e97-87a8-5544946c8ad4',
      data: ''
    },
    {
      id: '2465002c-74dd-407a-a481-90085a1b454c',
      type: 'Text',
      name: 'backBtnText',
      nameSpace: '',
      className: '',
      x: 1,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'BackToMap',
      localize: true,
      maxWidth: 185,
      maxHeight: 40,
      maxFontSize: 42,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8b5708',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '358c703a-5303-4d99-90df-3ca799184241',
      data: ''
    },
    {
      id: 'fcce9be3-e9f0-441c-96eb-36dc84d70b08',
      type: 'Sprite',
      name: 'notification',
      nameSpace: '',
      className: '',
      x: 58,
      y: 41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: '98f643b8-fcb6-4b0d-83fa-93b51a2d0195',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class FarmHudLayout {
  static raw = raw;
  root: PIXI.Container
  topContainer: PIXI.Container
  avatarNameSprite: PIXI.Sprite
  avatar: PIXI.Sprite
  circleMask: PIXI.Graphics
  avatarBorder: PIXI.Sprite
  nameText: PIXI.Text
  backButton: PIXI.Sprite
  backBtnText: PIXI.Text
  bottomContainer: PIXI.Container
  editButton: PIXI.Sprite
  notification: PIXI.Sprite
  shareButton: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
